import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-12 px-4 bg-cream-light border-t border-cream-dark" data-id="element-94">
      <div className="max-w-5xl mx-auto" data-id="element-95">
        <div className="text-center mb-12" data-id="element-96">
          <h3 className="text-xl md:text-2xl font-bold text-carbon mb-6 flex items-center justify-center gap-2" data-id="element-97">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="mb-8" data-id="element-98">
            <CountdownTimer data-id="element-99" />
          </div>
        </div>

        {/* Reusing PricingSection logic but without its own section padding/title */}
        <div className="mb-12" data-id="element-100">
          <PricingSection data-id="element-101" />
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-carbon-lighter font-medium bg-white py-6 rounded-2xl shadow-sm border border-cream-dark" data-id="element-102">
          <div className="flex items-center gap-2" data-id="element-103">
            <Lock className="w-5 h-5 text-brand-green" data-id="element-104" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-105">
            <Zap className="w-5 h-5 text-brand-green" data-id="element-106" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-107">
            <ShieldCheck className="w-5 h-5 text-brand-green" data-id="element-108" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-109">
            <CreditCard className="w-5 h-5 text-brand-green" data-id="element-110" /> Mercado Pago ·
            Tarjeta · Transferencia
          </div>
        </div>
      </div>
    </section>;
}